import {
  CJEVENT,
  DEVICE_DATA,
  REFERRAL_TOKEN,
} from 'consts/queryParameterConsts';

import { QUERY_PARAMS } from 'utils/queryParamHelpers';
import cookies from 'utils/storage/cookies';

/**
 * The referral token cookie has a special format, with the referred_by_type
 * data nested within it alongside the actual referral token. If we override
 * it without the referred_by_type, the backend will not be able to process
 * referrals correctly. The backend needs to be updated, but this will
 * prevent the collision for now.
 *
 * The device data param is used to pass device data to the device registration
 * call, but as it may be quite large and we don't use it elsewhere, we don't
 * want to store it in a cookie.
 */
const KEYS_TO_SKIP = [REFERRAL_TOKEN, DEVICE_DATA];

export default function convertQspsToCookies() {
  const queryParams = QUERY_PARAMS;

  if (!queryParams) {
    return;
  }

  queryParams.forEach((value, key) => {
    if (KEYS_TO_SKIP.includes(key)) {
      return;
    }

    if (key === CJEVENT) {
      cookies.set(key, value, { expires: 14 });
    } else {
      cookies.set(key, value);
    }
  });
}
